export default {"src":"/_next/static/media/robot.565b7ffc.svg","height":296,"width":535,"blurWidth":0,"blurHeight":0};